export default __webpack_public_path__ + "static/media/nodes-white.b4859bd1.svg";